import { InfoContainer, StyledContainer } from './styled';
import { Typography } from '@mui/material';
import { Credit } from 'types';
import { FunctionComponent, useEffect, useState } from 'react';
import { formatToCurrency } from 'utils';

interface Props {
  credit?: Credit;
  promoterName: string;
}

const ClientInformation: FunctionComponent<Props> = ({ credit, promoterName }: Props) => {
  const { amount, speiNumber, weeksSelected, weeklyPayment, createdBy } = credit || {};
  const [percentage, setPercentage] = useState<string>('Cargando...');

  useEffect(() => {
    const fetchPromoterData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_PUBLIC_URL}api/v2/reference/details/promoter/${createdBy}`,
        );
        console.log('response', response);
        const result = await response.json();
        if (result?.data?.percentage) {
          setPercentage(`${result.data.percentage}`);
        } else {
          setPercentage('N/A');
        }
      } catch (error) {
        console.error('Error fetching promoter data:', error);
        setPercentage('Error');
      }
    };

    if (createdBy) {
      fetchPromoterData();
    }
  }, [createdBy]);

  return (
    <StyledContainer>
      <Typography variant="h3">Información del crédito</Typography>
      <InfoContainer>
        <Typography variant="body2" color="GrayText">
          Monto del crédito
        </Typography>
        <Typography variant="body1">{formatToCurrency(amount || 0)}</Typography>
      </InfoContainer>
      <InfoContainer>
        <Typography variant="body2" color="GrayText">
          CLABE
        </Typography>
        <Typography variant="body1">{speiNumber || 'Desconocido'}</Typography>
      </InfoContainer>
      <InfoContainer>
        <Typography variant="body2" color="GrayText">
          Número de plazos
        </Typography>
        <Typography variant="body1">{weeksSelected || 8}</Typography>
      </InfoContainer>
      <InfoContainer>
        <Typography variant="body2" color="GrayText">
          Pago semanal
        </Typography>
        <Typography variant="body1">{formatToCurrency(weeklyPayment || 0)}</Typography>
      </InfoContainer>
      <InfoContainer>
        <Typography variant="body2" color="GrayText">
          Promotora
        </Typography>
        <Typography variant="body1">{promoterName}</Typography>
        <Typography variant="body2" color="GrayText">
          Porcentaje
        </Typography>
        <Typography variant="body1">{percentage}</Typography>
      </InfoContainer>
    </StyledContainer>
  );
};

export default ClientInformation;
